export default __webpack_public_path__ + "static/logo-footer-6c5dc9c08f391389ba9a3bcd6be4be65.png";